/**
 * Store region switcher — flag dropdown that redirects across domains.
 */
(function () {
  'use strict';

  class StoreRegionSwitcher extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-store-region-trigger]');
      this.menu = this.querySelector('[data-store-region-menu]');
      if (!this.trigger || !this.menu) return;

      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);

      this.trigger.addEventListener('click', this.onTriggerClick);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
      if (this.trigger) this.trigger.removeEventListener('click', this.onTriggerClick);
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeyDown);
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    open() {
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.menu.hidden = false;
    }

    close() {
      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.menu.hidden = true;
    }

    toggle() {
      if (this.isOpen) this.close();
      else this.open();
    }

    onTriggerClick(event) {
      event.preventDefault();
      event.stopPropagation();
      document.querySelectorAll('store-region-switcher.is-open').forEach((el) => {
        if (el !== this) el.close();
      });
      this.toggle();
    }

    onDocumentClick(event) {
      if (!this.isOpen) return;
      if (this.contains(event.target)) return;
      this.close();
    }

    onKeyDown(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.close();
        this.trigger.focus();
      }
    }
  }

  if (!customElements.get('store-region-switcher')) {
    customElements.define('store-region-switcher', StoreRegionSwitcher);
  }
})();
